import { PdlApplicationDetail } from '@/features';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/pdl/applications/$applicationId')({
  component: RouteComponent,
});

function RouteComponent() {
  return <PdlApplicationDetail />;
}
